import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { Cliente } from 'src/app/Models/cliente/cliente';
import { DetalleFactura } from 'src/app/Models/factura/detallefactura/detalle-factura';
import { Factura } from 'src/app/Models/factura/factura';
import { RangoFechas } from 'src/app/Models/rangofechas/rango-fechas';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import jsPDF from 'jspdf';
import { ReportViewerService } from 'src/app/Service/report-viewer.service';

@Component({
  selector: 'app-ventas-por-hora-vendedor',
  templateUrl: './ventas-por-hora-vendedor.component.html',
  styleUrls: ['./ventas-por-hora-vendedor.component.css']
})
export class VentasPorHoraVendedorComponent implements OnInit {

  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  public usuario: Usuario = new Usuario();
  public rangofechas: RangoFechas = new RangoFechas();
  public tipoinforme = 0;
  public funcion: Function = null;
  public isShow: boolean = false;
  public pagina: number = 0;
  public modal = "modal-lg";
  public zindex: number = 5000;
  public cliente: Cliente = new Cliente;
  public listclientes: Cliente[] = [];
  public alertType: AlertType = new AlertType();
  public facturas: Factura[] = [];
  public detfactus: DetalleFactura[] = [];
  public totalventas: number = 0;
  public totalefectivo: number = 0;
  public totaltarjetas: number = 0;
  public sumacantidad: number = 0;
  public sumatotal: number = 0;
  public empresa: any;
  public pagventas: any = 0;
  public vendedores: any[] = [];
  public today = new Date();
  public fechaHoraActual: Date = new Date()
  filtro: Filtro = new Filtro();
  constructor(public activeModal: NgbActiveModal, private data: DataService, private datePipe: DatePipe, private reportViewer: ReportViewerService) {
    this.filtro.idsucursal = this.data.getSucursalId();
  }

  ngOnInit() {
    this.getVendedores()
  }

  setInitialDates() {
    const today = new Date();
    this.filtro.fecfin = this.formatearFechas(today);

    // Obtener el primer día del mes
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    this.filtro.fecini = this.formatearFechas(firstDayOfMonth);
  }

  formatearFechas(fecha) {
    const parsedDate = moment(fecha, 'DD-MM-YYYY');
    fecha = parsedDate.format('YYYY-MM-DD');
    return fecha;
  }

  Ventas() {

    this.GetData();
  }

  getVendedores() {
    this.data.GetSimple(this.data.api.personal).subscribe(r => {
      this.vendedores = r;
      console.log(this.vendedores);

    })
  }


  setRango() {
    let fechainicio = this.formatearFechas(this.rangofechas.fecini);
    let fechafin = this.formatearFechas(this.rangofechas.fecfin);
    this.rangofechas.fecini = fechainicio;
    this.rangofechas.fecfin = fechafin;
  }

  async getClientes() {
    console.log("obteniendo clientes");
    await this.data.AsyncGetSimple(this.data.api.cliente).then(r => {
      this.listclientes = r;
    })
  }

  getEmpresa() {
    this.data.GetSimple(this.data.api.empresa).subscribe(r => {
      //console.log("Empresa:", r);
      this.empresa = r[0];
    }), (error) => {
      console.log(error);

    };
  }

  GetData() {
    this.data.Post('ventas_por_hora', this.filtro).subscribe(r => {
      console.log(r);
      if (r.length < 1) {
        console.error("Error");
      } else {
        this.facturas = r.data;
        const blob = this.generatePDF(this.facturas,
          { fecini: this.filtro.fecini, fecfin: this.filtro.fecfin },
          { title: 'INFORME DE VENTAS POR HORA Y VENDEDOR', today: new Date() });


        // Mostrar en el modal reutilizable
        if (blob) {
          const fecha = this.formatFecha(new Date(), 'yyyy-MM-dd');
          this.reportViewer.mostrarPDF(
            blob,
            'Lista de saldos',
            `lista_saldos_${fecha}.pdf`
          );
          this.close()
        }
      }
    }, (e => { console.log(e) }));
  }

  formatFecha(fecha: Date | string, format: string): string {
    // Formatear la fecha a 'dd-MM-yyyy'
    return this.datePipe.transform(fecha, format) || '';
  }

  generatePDF(
    data: any[],
    rangofechas: { fecini: string, fecfin: string },
    options: { title?: string, companyLogo?: string, today?: Date } = {}
  ): Blob | null {
    const doc = new jsPDF('landscape');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const titleText = options.title || 'INFORME DE VENTAS DETALLADO';
    const today = options.today || new Date();

    // márgenes y tamaños
    const marginLeft = 10;
    const marginRight = 10;
    const marginTop = 35;
    const marginBottom = 15;
    const usableWidth = pageWidth - marginLeft - marginRight;

    const fontSizeTitle = 14;
    const fontSizeHeader = 11;
    const fontSizeRow = 10;
    const baseLineHeight = 6; // altura por línea aprox

    // columnas solicitadas: serie, numero, fecha, hora, Descripcion, cantidad, precio, total
    const columns = [
      { key: 'serie', label: 'Serie', width: 18, align: 'left' },
      { key: 'numero', label: 'Numero', width: 20, align: 'left' },
      { key: 'fecha', label: 'Fecha', width: 22, align: 'left' },
      { key: 'hora', label: 'Hora', width: 18, align: 'left' },
      { key: 'Descripcion', label: 'Descripcion', width: 110, align: 'left' }, // columna larga
      { key: 'cantidad', label: 'Cantidad', width: 20, align: 'right' },
      { key: 'precio', label: 'Precio', width: 25, align: 'right' },
      { key: 'total', label: 'Total', width: 25, align: 'right' }
    ];

    // ajustar anchos si excede usableWidth
    const colTotalWidth = columns.reduce((s, c) => s + c.width, 0);
    if (colTotalWidth > usableWidth) {
      const scale = usableWidth / colTotalWidth;
      columns.forEach(c => c.width = Math.max(8, c.width * scale));
    }

    // formateadores
    const fmtDate = (iso: string) => {
      if (!iso) return '';
      try {
        const d = new Date(iso);
        if (isNaN(d.getTime())) return iso;
        const dd = String(d.getDate()).padStart(2, '0');
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const yyyy = d.getFullYear();
        return `${yyyy}-${mm}-${dd}`;
      } catch {
        return iso;
      }
    };
    const fmtTime = (iso: string) => {
      if (!iso) return '';
      try {
        const d = new Date(iso);
        if (isNaN(d.getTime())) return iso;
        const hh = String(d.getHours()).padStart(2, '0');
        const min = String(d.getMinutes()).padStart(2, '0');
        return `${hh}:${min}`;
      } catch {
        return iso;
      }
    };

    const numFmt = new Intl.NumberFormat('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    // encabezado por página
    const addHeader = (docRef: jsPDF) => {
      docRef.setFontSize(fontSizeTitle);
      const textWidth = docRef.getTextWidth(titleText);
      const titleX = (pageWidth / 2) - (textWidth / 2);
      docRef.text(titleText, titleX, 18);

      docRef.setLineWidth(0.5);
      docRef.line(titleX, 19, titleX + textWidth, 19);

      docRef.setFontSize(fontSizeHeader);
      const periodoText = `Del periodo ${this.formatFecha(rangofechas.fecini, 'dd-MM-yyyy')} al periodo ${this.formatFecha(rangofechas.fecfin, 'dd-MM-yyyy')}`;
      const generatedText = `Generado el dia ${this.formatFecha(today, 'dd-MM-yyyy hh:mm')}`;
      docRef.text(periodoText, marginLeft, 25);
      const genW = docRef.getTextWidth(generatedText);
      docRef.text(generatedText, pageWidth - marginRight - genW, 25);

      docRef.setFontSize(fontSizeRow);
    };

    // dibujar cabeceras de columnas (por página)
    const drawColumnHeaders = (docRef: jsPDF, y: number) => {
      docRef.setFontSize(fontSizeRow);
      docRef.setFont(undefined, 'bold');
      let x = marginLeft;
      for (const col of columns) {
        docRef.text(String(col.label), x, y);
        x += col.width;
      }
      docRef.setFont(undefined, 'normal');
      docRef.setLineWidth(0.3);
      docRef.line(marginLeft, y + 1.5, pageWidth - marginRight, y + 1.5);
      return y + 4;
    };

    // inicio
    let cursorY = marginTop;
    let pageNumber = 1;
    addHeader(doc);
    cursorY = drawColumnHeaders(doc, cursorY);

    // recorrer datos (cada row corresponde a un detalle)
    for (let i = 0; i < data.length; i++) {
      const row = data[i];

      // mapear valores esperados (asegurar keys)
      const values: Record<string, string | number> = {
        serie: row.serie || '',
        numero: row.numero || '',
        fecha: fmtDate(row.fecha || row.hora || ''),
        hora: fmtTime(row.hora || row.fecha || ''),
        Descripcion: row.Descripcion || row.descrip || row.descripcion || '',
        cantidad: row.cantidad != null ? numFmt.format(Number(row.cantidad)) : '',
        precio: row.precio != null ? numFmt.format(Number(row.precio)) : '',
        total: row.total != null ? numFmt.format(Number(row.total)) : ''
      };

      // calcular posiciones X de columnas
      const colXPositions: number[] = [];
      let x = marginLeft;
      for (const c of columns) {
        colXPositions.push(x);
        x += c.width;
      }

      // obtener líneas por columna (wrap para descripciones largas)
      const docRef = doc;
      const colLinesArr: string[][] = columns.map(col => {
        const raw = values[col.key] != null ? String(values[col.key]) : '';
        // permitir wrap para la columna larga (Descripcion) o si ancho>30
        if (col.width > 30) {
          return docRef.splitTextToSize(raw, col.width - 1);
        } else {
          return [raw];
        }
      });

      // altura de fila segun el mayor número de líneas
      const maxLines = Math.max(...colLinesArr.map(lines => lines.length));
      const rowHeight = Math.max(baseLineHeight, maxLines * baseLineHeight);

      // si no hay espacio suficiente -> nueva página
      if (cursorY + rowHeight > pageHeight - marginBottom) {
        // pie de página con número de página
        docRef.setFontSize(10);
        const pageText = `Página ${pageNumber}`;
        const pageW = docRef.getTextWidth(pageText);
        docRef.text(pageText, pageWidth - marginRight - pageW, pageHeight - 8);

        docRef.addPage();
        pageNumber++;
        addHeader(docRef);
        cursorY = marginTop;
        cursorY = drawColumnHeaders(docRef, cursorY);
      }

      // dibujar cada columna de la fila
      for (let ci = 0; ci < columns.length; ci++) {
        const col = columns[ci];
        const lines = colLinesArr[ci];
        const startX = colXPositions[ci];
        const startY = cursorY + 4; // baseline inicial

        if (col.align === 'right') {
          // juntamos líneas en una sola (normalmente números no envuelven)
          const text = lines.join(' ');
          const textW = docRef.getTextWidth(text);
          const tx = startX + col.width - 1 - textW;
          docRef.text(text, tx, startY);
        } else {
          // dibujar líneas verticalmente
          for (let li = 0; li < lines.length; li++) {
            const ty = startY + li * baseLineHeight;
            docRef.text(lines[li], startX, ty);
          }
        }
      }

      cursorY += rowHeight;
    }

    // Calcular total sumado de la columna 'total'
    const totalSum = data.reduce((acc, row) => acc + (Number(row.total) || 0), 0);

    // Dibujar línea de total al final
    // Si no hay espacio suficiente, crear nueva página
    const totalRowHeight = baseLineHeight + 2;
    if (cursorY + totalRowHeight > pageHeight - marginBottom) {
      doc.setFontSize(10);
      const pageText = `Página ${pageNumber}`;
      const pageW = doc.getTextWidth(pageText);
      doc.text(pageText, pageWidth - marginRight - pageW, pageHeight - 8);

      doc.addPage();
      pageNumber++;
      addHeader(doc);
      cursorY = marginTop;
      cursorY = drawColumnHeaders(doc, cursorY);
    }

    // Línea de total
    doc.setFontSize(fontSizeRow);
    doc.setFont(undefined, 'bold');
    let x = marginLeft;
    for (let ci = 0; ci < columns.length; ci++) {
      const col = columns[ci];
      if (col.key === 'total') {
        // Escribir "TOTAL" en la columna anterior (precio) si hay espacio, o en la columna de descripcion
        let totalLabelCol = columns.findIndex(c => c.key === 'precio');
        if (totalLabelCol === -1) totalLabelCol = columns.findIndex(c => c.key === 'Descripcion');
        if (ci === totalLabelCol + 1 && totalLabelCol >= 0) {
          // Escribir "TOTAL" en la columna anterior
          let totalLabelX = marginLeft;
          for (let j = 0; j < totalLabelCol; j++) {
            totalLabelX += columns[j].width;
          }
          doc.text('TOTAL', totalLabelX, cursorY + baseLineHeight);
        }
        // Escribir el total sumado en la columna 'total'
        const totalText = numFmt.format(totalSum);
        const totalTextW = doc.getTextWidth(totalText);
        const tx = x + col.width - 1 - totalTextW;
        doc.text(totalText, tx, cursorY + baseLineHeight);
      }
      x += col.width;
    }
    doc.setFont(undefined, 'normal');

    // pie de página última página
    doc.setFontSize(10);
    const finalPageText = `Página ${pageNumber}`;
    const finalW = doc.getTextWidth(finalPageText);
    doc.text(finalPageText, pageWidth - marginRight - finalW, pageHeight - 8);

    return doc.output('blob');
  }

  close() {
    this.activeModal.dismiss('cancelado');
  }
}
